import { EventSpecs, EventConfig } from './eventTypes'
import throttler, { WtaEndpointResponse } from './throttler';
import { structureData } from './structureData';
import { isInitialized, getInitPromise } from './sendGate';
import logger from './logger';

export type MetaSpecsInternal = {
    eventTime: Date;
};

export type EventFn = (eventSpecs: EventSpecs, eventConfig?: EventConfig) => Promise<WtaEndpointResponse | Error>

// Note that we have *not* made this function an async. This is because the function must be sync
// up until `structureData` is called
const event: EventFn = ({ type, meta = {}, data }, eventConfig = { force: false }) => {
    const { queueEvent } = throttler;
    const { force } = eventConfig;

    // Include the datetime if the caller has not:
    const eventTime = meta.eventTime || new Date;
    const metaInternal = { eventTime } as MetaSpecsInternal;
    let sendPromise: Promise<WtaEndpointResponse | Error>;
    if (isInitialized()) {
        // The app already initialized RSW. We can create events synchronously:
        const structuredData = structureData({ type, data, meta: metaInternal })
        // Queue event for sending
        sendPromise = queueEvent(structuredData, force);
    } else {
        // We've determined that RSW has not been initialized.  This means we need to pause event
        // creation until initialization has taken place.  Otherwise, events with missing data will
        // be sent out.

        // Thenning off of the following promise ensures that all boilerplate data is in state,
        // before structuring of state data is attempted. In other words, event creation will be
        // paused until RSW is initialized with the proper state for creating events.
        sendPromise = getInitPromise().then(() => {
            // Now that we can be sure the app was initialized, we can create and queue events for send:
            const structuredData = structureData({ type, data, meta: metaInternal })
            return queueEvent(structuredData, force);
        }).catch(e => {
            logger.error(e);
            return e;
        });
    }
    return sendPromise
};

export default event;
